import React, { useEffect } from "react";
import { useAppContext } from "../../../../context/AppContext";
import { cn } from "../../../../lib/utils";
import { useFormContext } from "react-hook-form";

const ColourTypeTabs = ({ setValue, oxide, view, name, componentName, input_name }) => {
    const {
        state,
        setSelectedInternalColourType,
        setSelectedInternalSlabColourType,
        setSelectedExternallColourType,
        setSelectedExternalFrameColourType,
        setSelectedExternalSlabColourType,
        setIsOxide
    } = useAppContext();

    const {
        selectedInternalColourType,
        selectedInternalSlabColourType,
        selectedExternalColourType,
        selectedExternalFrameColourType,
        selectedExternalSlabColourType
    } = state;

    // Determine current colour type and setter based on section name
    let currentColourType, setCurrentColourType;

    if (view === "internal") {
        if (name === "Internal Panel Colour") {
            currentColourType = selectedInternalSlabColourType;
            setCurrentColourType = setSelectedInternalSlabColourType;
        } else {
            currentColourType = selectedInternalColourType;
            setCurrentColourType = setSelectedInternalColourType;
        }
    } else {
        if (name === "External Panel Colour") {
            currentColourType = selectedExternalSlabColourType;
            setCurrentColourType = setSelectedExternalSlabColourType;
        } else if (name === "External Frame Colour") {
            currentColourType = selectedExternalFrameColourType;
            setCurrentColourType = setSelectedExternalFrameColourType;
        } else {
            currentColourType = selectedExternalColourType;
            setCurrentColourType = setSelectedExternallColourType;
        }
    }
    const { watch } = useFormContext();

    const selectedDoor = watch("external_door_style");

    return (
        <div className="flex w-full gap-4 py-2">
            <button
                type="button"
                className={cn("uppercase text-gray-700 text-xs", {
                    ["text-primary border-b border-b-primary"]: currentColourType === "standard",
                })}
                onClick={() => {
                    setIsOxide(false)
                    setCurrentColourType("standard");

                    if (view === "internal") {
                        if (name === 'Internal Panel Colour') {
                            setValue("internal_slab_colour", "ral_7016");
                            setValue('internal_slab_colour_type','standard')
                        } else {
                            setValue("internal_door_colour", "ral_7016");
                            setValue('internal_door_colour_type','standard')
                        }
                    } else {
                        if( name === 'External Panel Colour' ) {
                            setValue("panel", "ral_7016");
                            setValue('external_slab_colour_type','standard')
                        } else {
                            setValue("external_door_colour", "ral_7016");
                            setValue('external_door_colour_type','standard')
                            setValue('oxide_frame_colour', "ral_7016");
                        }
                    }
                }}
            >
                Standard
            </button>
            <button
                type="button"
                className={cn("uppercase text-gray-700 text-xs", {
                    ["text-primary border-b border-b-primary"]: currentColourType === "nonstandard",
                })}
                onClick={() => {
                    setIsOxide(false)
                    setCurrentColourType("nonstandard");

                    if (view === "internal") {
                        if (name === 'Internal Panel Colour') {
                            setValue("internal_slab_colour", "ral_9010");
                            setValue('internal_slab_colour_type','nonstandard')
                        } else {
                            setValue("internal_door_colour", "ral_9010");
                            setValue('internal_door_colour_type','nonstandard')
                        }
                    } else {
                        if (name === 'External Panel Colour') {
                            setValue("panel", "ral_9010");
                            setValue('external_slab_colour_type','nonstandard');
                        } else {
                            setValue("external_door_colour", "ral_9010");
                            setValue('external_door_colour_type','nonstandard');
                        }
                    }
                }}
            >
                nonstandard
            </button>
            {selectedDoor === "sumatra" && !!oxide && view === "external" && (
                <button
                    type="button"
                    className={cn("uppercase text-gray-700 text-xs", {
                        ["text-primary border-b border-b-primary"]: currentColourType === "oxide",
                    })}
                    onClick={() => {
                        setIsOxide(true)

                        setCurrentColourType("oxide");

                        if (view === "internal") {
                            if (name === 'Internal Panel Colour') {
                                setValue("internal_slab_colour", "bruno");
                                setValue('internal_slab_colour_type','oxide')
                            } else {
                                setValue("internal_door_colour", "bruno");
                                setValue('internal_door_colour_type','oxide')
                            }
                        } else {
                            if (name === 'External Panel Colour') {
                                setValue("panel", "bruno");
                                setValue('external_slab_colour_type','oxide')
                            } else {
                                setValue("external_door_colour", "bruno");
                                setValue('external_door_colour_type','oxide')
                            }
                        }

                    }}
                >
                    Premium Range
                </button>
            )}
        </div>
    );
};

export default ColourTypeTabs;
